<template>
    <div class="report-relate">
        <div class="tools-bar" style="float: right !important;">
            <div class="tools-btn-group">
                <!-- <el-button icon="el-icon-s-data" v-if="processInstanceId&&!searchParams.isAllData" type="primary" @click="handleShowOrgTreeView" >树视图</el-button>-->
                <el-button icon="el-icon-download" type="primary" @click="exportReportRelateTreeList" :loading="exportLoading">导出</el-button>
            </div>
        </div>
        <tree-table :data="treeListData" :isShowCheckbox="false" :expandAll="true" :isShowOrgTree="true" :columns="treeColumns" @showOrgTreeView="showOrgTreeView" border />
        <el-dialog
            title=""
            :visible.sync="isShowOrgTreeDialog"
            :fullscreen = true
            append-to-body
            >
            <VueOrgTree ref="reportOrgTree" :key="loadTimer" :treeData="treeOrgData"/>
        </el-dialog>
    </div>
</template>

<script>
import VueOrgTree from '@/components/VueOrgTree';
import TreeTable from '@/components/TreeTable';
import { getModelFormReportTree, getModelFormReportOrgTree, getProcessInstanceFormCnt } from '@/data-model';
import { API_EXPORT_MODEL_FORM_EXCEL } from '@/common/constants';
export default {
    components: {
        TreeTable,
        VueOrgTree
    },
    data () {
        return {
            treeOrgData: {},
            loadTimer: '',
            isShowOrgTreeDialog: false,
            exportLoading: false,
            treeListData: [],
            treeColumns: [],
            selectNodeId: 0,
            popoverTreeLable: '',
            searchParams: {
                isAllData: this.isAllData,
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: ''
            },
            page: {
                currentPage: 1, // 当前页码
                pageSize: 50000, // 每页条数
                totalPageNum: 1 // 总页数
            }
        };
    },
    props: {
        processInstanceId: {
            // 当前流程实例ID
            type: String
        },
        modelId: {
            type: String
        },
        formId: {
            type: String
        },
        isAllData: {// 是否显示所有报表的业务数据树结构
            type: Boolean,
            default: false
        }
    },
    created () {
        // this._initPage();
    },
    methods: {
        async _initPage () {
            if (this.isAllData) {
                this.handleViewProcessRelate();
            } else {
                this.getProcessInstanceFormCnt();
            }
        },
        async getProcessInstanceFormCnt () {
            let formData = await getProcessInstanceFormCnt(this.formId, this.processInstanceId);
            // console.log(formData);
            if (formData.cnt > 0) {
                this.handleViewProcessRelate();
            } else { // 查看所有
                this.searchParams.isAllData = true;
                this.handleViewProcessRelate();
            }
        },
        async handleViewProcessRelate () {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // this.searchParams.modelId = '4e0e17e869454a5fb08c15066ce03516';
            // this.searchParams.formId = 'b0452c759f574cfa9d8c80ed4c935350';
            this.searchParams.modelId = this.modelId;
            this.searchParams.formId = this.formId;
            this.searchParams.isFilterDuplicateData = true;
            this.searchParams.processInstanceId = this.processInstanceId;
            let formData = await getModelFormReportTree(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            if (formData && formData.otherData) {
                // console.log(formData.otherData.tableColumns);
                this.treeColumns = formData.otherData.tableColumns;
                this.treeListData = [];
                if (formData.data) {
                    let tableDatas = [];
                    formData.data.forEach(item => {
                        let jsonObj = JSON.parse(item);
                        tableDatas.push(jsonObj);
                    });
                    this.treeListData = tableDatas;
                }
                // console.log(this.treeListData);
            }
            loading.close();
        },
        async exportReportRelateTreeList () {
            let url = `${API_EXPORT_MODEL_FORM_EXCEL}`;
            url = url.replace(':modelId', this.modelId).replace(':processInstanceId', this.processInstanceId).replace(':isApprovalForm', false).replace(':needSumData', false).replace(':processInstanceId', this.processInstanceId).replace('isAllData=false', 'isAllData=' + this.searchParams.isAllData);
            this.exportLoading = true;
            this.download(url);
            setTimeout(() => { // 导出按钮转圈圈关闭
                this.exportLoading = false;
            }, 5000);
        },
        download (url) {
            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);
        },
        async showOrgTreeView (row) {
            this.loadTimer = new Date().getTime();
            let formData = await getModelFormReportOrgTree(this.formId, row.id);
            this.treeOrgData = {};
            if (formData.data) {
                let tableDatas = {};
                formData.data.forEach(item => {
                    tableDatas = JSON.parse(item);
                });
                this.treeOrgData = tableDatas;
            }
            this.isShowOrgTreeDialog = true;
        }
    }
};
</script>

<style lang="less">
// .el-dialog__body {
//     height: ~'calc(100% - 16vh)';
    .report-relate {
        width: ~'calc(100% - 2vw)';
        height:100%;
        // position: absolute;
        .el-table{
            height:100%;
        }
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
        .el-table--border {
            border-bottom: 1px solid #ebeef5;
        }
        .has-gutter {
            .gutter {
                width: 17px !important;
            }
        }
    }
// }


</style>



// WEBPACK FOOTER //
// src/components/ReportRelateTree/ReportRelateTree2.vue